<template>
    <div class="content">
        <!-- 题目 -->
        <el-col :span="24" class="tiMu" align="left"><div class="disIn hybrid" v-html="`${serial}、${heart.questionDto.question}  ( ${heart.score}分 )`">{{`${serial}、${heart.questionDto.question} ( ${heart.score}分 )`}}</div></el-col>
        <!-- 单选题 -->
        <div v-if="heart.questionDto.typeCode == 10" class="contentBox">
            <single-choice ref="typeCodeRef" :sonData="heart" keep-alive></single-choice>
        </div>
        <!-- 多选题 -->
        <div v-if="heart.questionDto.typeCode == 11" class="contentBox">
            <multiple-choice ref="typeCodeRef" :sonData="heart" keep-alive></multiple-choice>
        </div>
        <!-- 判断题 -->
        <div v-if="heart.questionDto.typeCode == 12" class="contentBox">
            <judgment-questions ref="typeCodeRef" :sonData="heart" keep-alive></judgment-questions>
        </div>
        <!-- 听音填写 -->
        <div v-if="heart.questionDto.typeCode == 20" class="contentBox">
            <listen-write ref="typeCodeRef" :sonData="heart" keep-alive></listen-write>
        </div>
        <!-- 视唱 -->
        <div v-if="heart.questionDto.typeCode == 30" class="contentBox">
            <sightsinging ref="typeCodeRef" :sonData="heart" keep-alive></sightsinging>
        </div>
        <!-- 填空题 -->
        <div v-if="heart.questionDto.typeCode == 50" class="contentBox">
            <fill-blanks ref="typeCodeRef" :sonData="heart" keep-alive></fill-blanks>
        </div>
        <!-- 节奏题打谱 -->
        <div v-if="heart.questionDto.typeCode == 60" class="contentBox">
            <rhythm-dp-choice ref="typeCodeRef" :sonData="heart" keep-alive></rhythm-dp-choice>
        </div>
        <!-- 节奏题视唱 -->
        <div v-if="heart.questionDto.typeCode == 61" class="contentBox">
            <rhythm-sc-choice ref="typeCodeRef" :sonData="heart" keep-alive></rhythm-sc-choice>
        </div>
    </div>
</template>
<script>
import rhythmDpChoice from '../../components/examRecords/rhythmDpChoice'
import rhythmScChoice from '../../components/examRecords/rhythmScChoice'
import singleChoice from '../../components/examRecords/singleChoice_err'
import multipleChoice from '../../components/examRecords/multipleChoice'
import judgmentQuestions from '../../components/examRecords/judgmentQuestions'
import listenWrite from '../../components/examRecords/listenWrite'
import fillBlanks from '../../components/examRecords/fillBlanks'
import sightsinging from '../../components/examRecords/sightsinging'
import utils from '../../lib/util'
    export default {
        name:"topic",
        props: {
            questionText: Object,
            serial:Number,
            answer:Object,
        },
        data() {
            return {
               heart:{
                    questionDto:{
                       question:''
                    }
               },
            }
        },
        components:{
            rhythmDpChoice,
            rhythmScChoice,
            singleChoice,
            multipleChoice,
            judgmentQuestions,
            listenWrite,
            fillBlanks,
            sightsinging
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.$nextTick(function(){
                this.process(this.questionText)
            })
        },
        methods:{
            process(val){
                this.heart = utils.deepClone2(val)
                this.heart.questionDto.question = utils.dealText(this.heart.questionDto.question)
                this.heart.errorObj = this.answer
            },

            /**
             * 判断是否已答题
             * return：Boolean
             */
            whetherAnswer(){
                return this.$refs.typeCodeRef.yesNotProblem()
            },

            // 切换下一题结束音频
            endAudio(){
                return this.$refs.typeCodeRef.endAudio()
            },
        }
    }
</script>
<style scoped lang="less">
    .content{
        height: 100%;
        width: 100%;
        position: relative;
    }
    .tiMu{
        display: block;
        position: absolute;
        top: 0;
        height: 50px;
        width: 100%;
        margin-bottom: 5px;
        box-sizing: border-box;
        padding-left: 16px;
        font-weight: bold;
    }
    .audioCom{
        display: inline-block;
        vertical-align: bottom;
    }
    .playNum{
        display: inline-block;
        width: 48px;
        padding-top: 5px;
        text-align: right;
        position: relative;
        margin-left: 15px;
        .playNumIng{
            position: absolute;
            top: 14%;
            bottom: 5%;
            left: 0;
            img{
                height: 100%;
            }
        }
    }
    .contentBox{
        margin-top: 52px;
        position: absolute;
        top: 0%;
        bottom: 0;
        width: 100%;
        
    }
</style>
<style>
    .disIn{float:left}
    .hybrid .tableimg{
        height: 50px;
        width: 90px;
        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .hybrid .tableimg .view{
        height: 50px;
        width: 90px;
    }
    .hybrid .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        margin: auto auto;
    }
    .hybrid video{
        width: 130px;
        height: 100px;
        outline: none;
    }   
    .hybrid audio{
        width: 250px;
        height: 35px;
        outline: none;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/examRecords/errTopic.vue